import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import { CONTACTS_BASE_URL } from "../contactsManagement/contactsConfig";
import { WELLS_BASE_URL } from "../wellsManagement/wellsConfig";

export function useWellRegistrationLookups() {
  const { getAccessTokenSilently } = useAuth0();

  const contactsQuery = useQuery(["contacts"], async () => {
    const token = await getAccessTokenSilently();
    const res = await axios.get(CONTACTS_BASE_URL, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  });

  const wellsQuery = useQuery(["wells"], async () => {
    const token = await getAccessTokenSilently();
    const res = await axios.get(WELLS_BASE_URL, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  });

  return {
    contacts: contactsQuery.data || [],
    wells: wellsQuery.data || [],
  };
}
